import {Component, ElementRef, HostListener, input, signal, viewChild} from "@angular/core";
import {SlicePipe} from "@angular/common";
import {SimStatusPalette, SimUser} from "@models";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {explicitEffect} from "ngxtension/explicit-effect";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {Translations} from "@translations";
import {TranslateModule} from "@ngx-translate/core";

@Component({
	selector: "sim-exam-schedule-student-item",
	imports: [SlicePipe, MatIcon, MatTooltip, TranslateModule],
	host: {
		"[class.locked]": "isLocked()",
		"[class.unlocked]": "!isLocked()",
		"[class.compact]": "compact()",
		"[class.warn]": "duplicateCount()",
	},
	animations: [zoomInOnEnterAnimation({duration: 175}), zoomOutOnLeaveAnimation({duration: 175})],
	templateUrl: "./exam-schedule-student-item.component.html",
	styleUrl: "./exam-schedule-student-item.component.scss",
})
export class ExamScheduleStudentItemComponent {
	// I/O
	public readonly student = input.required<SimUser>();
	public readonly color = input.required<string>();
	public readonly isLocked = input<boolean>(false);
	public readonly compact = input<boolean>(false);
	public readonly duplicateCount = input<number>(0);

	// Constants
	protected readonly T = Translations;
	protected readonly SimStatusPalette = SimStatusPalette;

	// Children
	protected readonly studentName = viewChild<ElementRef<HTMLSpanElement>>("studentName");

	// Properties
	protected readonly showTooltip = signal<boolean>(false);

	// Effects
	readonly #initEffect = explicitEffect([this.studentName], () => {
		setTimeout(() => this.checkOverflow(), 500);
	});

	@HostListener("window:resize", ["$event.target"])
	public checkOverflow(): void {
		const element = this.studentName()?.nativeElement;
		if (element) {
			this.showTooltip.set(element.offsetWidth < element.scrollWidth);
		}
	}
}
